export class WpTranslationItem {

    constructor(
        public french: string,
        public dutch: string,
        public english: string,
        public sortOrder: number,
        public id?: number,
        public deleted?: boolean
    ){}
}
